/* eslint-disable no-prototype-builtins */
/* eslint-disable react/jsx-key */
/* eslint-disable array-callback-return */
import React, { useState, useEffect, useRef, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import ReactTooltip from "react-tooltip";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

import { helperFunction } from "../../constant/helper";
import {
  locationActions,
  ruleActions,
  userActions
} from "../../redux/actions";
import { buttonsArray, toolTipData } from "./userData";
import { getAllDepartment } from "../../redux/actions/hrActions";
import { statusOfUser } from "../../constant/loginType/loginTypeConstant";
import { UserTypes } from "../../redux/type/type";
import Button from "../../component/button/Button";
import Card from "../../component/card/Card";
import DynamicTopInput from "./DynamicTopInput";
import HeaderTag from "../../component/smallComponents/HeaderTag";
import isEmpty from "../../validation/isEmpty";
import RenderToolTip from "../../component/tooltip/RenderToolTip";
import SelectInput2 from "../../component/input/SelectInput2";
import TopInput from "./TopInput";
import UserList from "./UserList";
import Starter from "../../component/Starter";
// import EnhancedTable from "../../component/table/EnhancedTable";

const initialState = {
  Filter: "",
  workerId: "",
  locationId: "",
  userDepartment: "",
  activeStatus: true
};

const AllUsers = () => {
  const loginType = localStorage.loginType;
  const componentRef = useRef();
  const dispatch = useDispatch();
  const [next, setNext] = useState({});
  const [allUsers, setAllUsers] = useState([]);
  const [allRules, setAllRules] = useState([]);
  const [ruleCode, setRuleCode] = useState("");
  const [department, setDepartment] = useState([]);
  const [isDynamic, setIsDynamic] = useState(false);
  const [values, setValues] = useState(initialState);
  const [allLocations, setAllLocations] = useState([]);
  const [ruleShiftType, setRuleShiftType] = useState("");
  const [selectedRuleId, setSelectedRuleId] = useState("");
  const [ruleLocationName, setRuleLocationName] = useState("");
  const [selectedValues, setSelectedValues] = useState([]);

  const {
    users,
    filter,
    dynamic,
    nextPage,
    workerId,
    userError,
    locationId,
    userLoading,
    activeStatus,
    userResponse,
    selectedDepartment,
    deleteFaceSuccess,
    selectedInputs
  } = useSelector((state) => state.user);

  const { activeNow } = useSelector((state) => state.rule);
  const { currentUser } = useSelector((state) => state.auth);
  const { allDepartments } = useSelector((state) => state.hr);
  const { locations } = useSelector((state) => state.location);

  const commonDispatch = () => {
    dispatch(userActions.setUserLoading(true));
    dispatch(userActions.clearUserErrors());
    dispatch(userActions.clearUserResult());
    dispatch(userActions.unmountAllUsersData());
  };

  const onHandleDynamicChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
    if (name === "locationId" && value !== "ALL") {
      dispatch(ruleActions.getAllRulesByLocationId(value, loginType));
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "locationId") {
      dispatch(ruleActions.getAllRulesByLocationId(value, loginType));
    }
    setValues({
      ...values,
      [name]: value
    });
  };

  useEffect(() => {
    if (userError) {
      helperFunction.toastHelper("error", userError);
    }
    dispatch(userActions.clearUserErrors());
    if (userResponse) {
      helperFunction.toastHelper("success", userResponse);
    }
    dispatch(userActions.clearUserResult());
    if (!isEmpty(deleteFaceSuccess)) {
      deleteFaceSuccess.map((data) => {
        helperFunction.toastHelper("success", data);
      });
    }
  }, [userError, userResponse, deleteFaceSuccess]);

  // on locationId from redux
  useEffect(() => {
    setValues({
      ...values,
      filter,
      workerId,
      locationId,
      activeStatus,
      userDepartment: selectedDepartment
    });
    setIsDynamic(dynamic);
  }, [
    filter,
    dynamic,
    workerId,
    locationId,
    activeStatus,
    selectedDepartment
  ]);

  // next page and all users
  useEffect(() => {
    if (!isEmpty(users)) {
      setAllUsers(users);
    }

    setNext(nextPage);
  }, [users]);

  useEffect(() => {
    if (locations !== null) {
      setAllLocations(locations);
    } else {
      setAllLocations([]);
    }
  }, [locations]);

  useEffect(() => {
    if (allDepartments !== null) {
      setDepartment(allDepartments);
    } else {
      setDepartment([]);
    }
  }, [allDepartments]);

  useEffect(() => {
    if (selectedInputs !== null) {
      setSelectedValues(selectedInputs);
    } else {
      setSelectedValues([]);
    }
  }, [selectedInputs]);

  useEffect(() => {
    const ruleArray = [];
    if (activeNow !== null) {
      activeNow.map((singleRule) => {
        ruleArray.push({
          _id: singleRule._id,
          shiftIn: singleRule.shiftIn,
          shiftOut: singleRule.shiftOut,
          shiftCode: singleRule.shiftCode,
          shiftType: singleRule.shiftType,
          locationName: singleRule.locationName,
          locationType: singleRule.locationType
        });
      });
      setAllRules(ruleArray);
    } else {
      setAllRules([]);
    }
  }, [activeNow]);

  useEffect(() => {
    // location
    dispatch(locationActions.clearLocationErrors());
    dispatch(locationActions.clearLocationResult());
    dispatch(getAllDepartment(loginType));
    // dispatch(locationActions.getAllLocation(loginType));
    return () => {
      dispatch(userActions.clearUserErrors());
      dispatch(userActions.clearUserResult());
      // dispatch(userActions.unmountAllUsersData());
    };
  }, []);

  const defaultValueFunction = () => {
    const selectedChoice = {};
    selectedValues.map((i) => {
      selectedChoice[i.value] = 1;
    });
    const newObject = {
      workerId: 1,
      isActive: 1,
      isRestrict: 1,
      workerType: 1,
      allowFencing: 1,
      locationName: 1,
      workerSurname: 1,
      workerFirstName: 1,
      workerMiddleName: 1,
      appliedRule: 1,
      workerDepartment: 1,
      workerDesignation: 1,
      workerFaceRegistered: 1,
      isBackupDetectionImage: 1
    };
    Object.keys(selectedChoice).forEach(function (key) {
      newObject[key] = selectedChoice[key];
    });
    return JSON.stringify(newObject);
  };

  // on load more click
  const onLoadMoreClick = () => {
    const dataToGetAllUser = defaultValueFunction();
    dispatch(
      userActions.getAllUsers(
        "loadMore",
        loginType,
        values.locationId,
        values.activeStatus,
        values.userDepartment,
        values.Filter,
        values.workerId,
        isDynamic,
        next.page,
        next.limit,
        dataToGetAllUser,
        selectedValues
      )
    );
  };

  // change dynamic inputs
  const handleSelectCategories = (input) => {
    setSelectedValues(input);
  };

  // get All Workers By Specific Inputs
  const getAllWorkersBySpecificInputs = () => {
    const dataToGetAllUser = defaultValueFunction();
    commonDispatch();
    dispatch(
      userActions.getAllUsers(
        "initial",
        loginType,
        values.locationId,
        values.activeStatus,
        values.userDepartment,
        values.Filter,
        values.workerId,
        isDynamic,
        1,
        100,
        dataToGetAllUser,
        selectedValues
      )
    );
  };

  const getUserByWorkerId = (e) => {
    e.preventDefault();
    const { workerId, locationId } = values;
    if (workerId === "" || locationId === "") {
      const errorData = {
        data: {
          message: "Location Not Select or Employee Id is Empty"
        },
        status: 400
      };
      return dispatch({
        type: UserTypes.USER_GET_ERRORS,
        payload: errorData
      });
    } else {
      const dataToGetAllUser = defaultValueFunction();
      commonDispatch();
      dispatch(
        userActions.getAllFilterUsers(
          locationId,
          workerId,
          loginType,
          isDynamic,
          dataToGetAllUser,
          selectedValues
        )
      );
    }
  };

  // reset password
  const resetPassword = (e, userDetail) => {
    e.preventDefault();
    dispatch(userActions.clearUserErrors());
    dispatch(userActions.clearUserResult());
    dispatch(userActions.resetPassword(userDetail._id, loginType));
  };

  // delete face
  const deleteFace = (e, userDetail) => {
    e.preventDefault();
    dispatch(userActions.clearUserErrors());
    dispatch(userActions.clearUserResult());
    dispatch(userActions.deleteFace(userDetail._id, loginType));
  };

  // on multiFunctionButton
  const multiFunction = async (e, boolValue, type) => {
    e.preventDefault();
    const arrayIds = [];
    await allUsers.forEach((foundUser) => {
      if (foundUser.select) {
        arrayIds.push(foundUser._id);
      }
    });
    dispatch(userActions.clearUserErrors());
    dispatch(userActions.clearUserResult());
    if (arrayIds.length === 0) {
      const errorData = {
        data: { message: "Please Select User, List is Empty" },
        status: 400
      };
      return dispatch({
        type: UserTypes.USER_GET_ERRORS,
        payload: errorData
      });
    } else {
      const idsArray = {
        arrayOfUserIds: arrayIds
      };
      dispatch(
        userActions.onGeoActiveRestrict(
          idsArray,
          type,
          loginType,
          allUsers,
          boolValue
        )
      );
    }
  };

  const onApplyRuleSubmit = async (e) => {
    e.preventDefault();
    const arrayIds = [];
    await allUsers.forEach((foundUser) => {
      if (foundUser.select) {
        arrayIds.push(foundUser._id);
      }
    });
    dispatch(userActions.clearUserErrors());
    dispatch(userActions.clearUserResult());
    if (arrayIds.length === 0) {
      const errorData = {
        data: { message: "Please Select User, List is Empty" },
        status: 400
      };
      return dispatch({
        type: UserTypes.USER_GET_ERRORS,
        payload: errorData
      });
    } else {
      const idsArray = {
        arrayOfUserIds: arrayIds,
        ruleId: selectedRuleId
      };
      dispatch(
        userActions.onAssigningRuleToUser(
          idsArray,
          loginType,
          allUsers,
          ruleLocationName,
          ruleShiftType,
          ruleCode
        )
      );
    }
  };

  const onRuleSelect = (e) => {
    const { value } = e.target;
    const foundRule = allRules.find(
      (element) => element._id === value
    );
    setSelectedRuleId(value);
    setRuleLocationName(foundRule.locationName);
    setRuleCode(foundRule.shiftCode);
    setRuleShiftType(foundRule.shiftType);
  };

  const renderMultipleButton = () => {
    return buttonsArray.map((buttonArray, index) => (
      <Fragment key={index}>
        <Button
          data-tip
          type="button"
          title={buttonArray.title}
          isBackgroundColor={false}
          data-for={buttonArray._id}
          icon={`${buttonArray.icon} mr-2`}
          onClick={(e) =>
            multiFunction(e, buttonArray.bool, buttonArray.name)
          }
          className={`${buttonArray.className} mb-2 mr-2`}
        />
        <ReactTooltip
          place="top"
          effect="solid"
          id={buttonArray._id}
          type={buttonArray.toolTipColor}
        >
          {buttonArray.toolTipText}
        </ReactTooltip>
      </Fragment>
    ));
  };

  return (
    <Starter
      topBarTitle={`All ${loginType}`}
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Registration Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Registration</a>
          </li>
          <li className="breadcrumb-item active">{`All ${loginType}`}</li>
        </Fragment>
      }
    >
      <RenderToolTip toolTipData={toolTipData} />

      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
          {renderMultipleButton()}
          <Card>
            <div className="row">
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3">
                <SelectInput2
                  data-tip
                  name="isDynamic"
                  isLabeled={true}
                  value={isDynamic}
                  data-for="isDynamic"
                  icon="mdi mdi-playlist-check"
                  label="Select Search Data Type"
                  placeholder="Select Search Data Type"
                  onChange={(e) => setIsDynamic(!isDynamic)}
                >
                  <option value={false}>ALL DATA</option>
                  <option value={true}>FILTER DATA</option>
                </SelectInput2>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3">
                <SelectInput2
                  data-tip
                  isLabeled={true}
                  label="Select Rule"
                  name="selectedRuleId"
                  value={selectedRuleId}
                  onChange={onRuleSelect}
                  data-for="selectedRuleId"
                  placeholder="Select Rule"
                  icon="mdi mdi-textbox-password"
                >
                  {allRules.map((rule, index) => (
                    <option value={rule._id} key={index}>
                      {rule.shiftCode +
                        " / " +
                        rule.shiftIn +
                        " - " +
                        rule.shiftOut}
                    </option>
                  ))}
                </SelectInput2>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-2 col-sm-2">
                <Button
                  data-tip
                  type="button"
                  title="Apply RULE"
                  data-for="applyRule"
                  isBackgroundColor={false}
                  onClick={onApplyRuleSubmit}
                  icon="mdi mdi-database-plus mr-2"
                  className="btn text-white btn-block btn-primary "
                />
              </div>
              <div className="col-xl-3 col-lg-3 col-md-2 col-sm-2">
                <ReactHTMLTableToExcel
                  data-tip
                  sheet="Sheet"
                  data-for="exportToExcel"
                  buttonText="Export excel"
                  table="products-datatable"
                  className="btn btn-dark btn-block"
                  filename={`${values.locationId}_${values.activeStatus}`}
                />
              </div>
            </div>
            {isDynamic ? (
              <DynamicTopInput
                values={values}
                currentUser={currentUser}
                allLocations={allLocations}
                selectedValues={selectedValues}
                onChange={onHandleDynamicChange}
                getUserByWorkerId={getUserByWorkerId}
                handleSelectCategories={handleSelectCategories}
              />
            ) : (
              <Fragment>
                <HeaderTag
                  type="h3"
                  isClassName={true}
                  className="text-danger"
                  title="Only First 100 Data Will be shown as per name, Please click on LOAD MORE button to get more data"
                />
                <TopInput
                  values={values}
                  department={department}
                  currentUser={currentUser}
                  allLocations={allLocations}
                  statusOfUser={statusOfUser}
                  onChange={handleInputChange}
                  onLoadMoreClick={onLoadMoreClick}
                  selectedValues={selectedValues}
                  handleSelectCategories={handleSelectCategories}
                  getAllWorkersBySpecificInputs={
                    getAllWorkersBySpecificInputs
                  }
                />
              </Fragment>
            )}

            {/* <EnhancedTable /> */}
          </Card>
          <Card>
            <UserList
              allUsers={allUsers}
              Filter={values.Filter}
              reference={componentRef}
              currentUser={currentUser}
              userLoading={userLoading}
              setAllUsers={setAllUsers}
              onDeleteFace={deleteFace}
              dynamicHeader={selectedValues}
              onResetPassword={resetPassword}
            />
            <div className="row mt-3">
              <div className="col-sm-1"></div>
              <div className="col-sm-4"></div>
              <div className="col-2">
                <Button
                  data-tip
                  type="button"
                  title="Load More"
                  data-for="loadMore"
                  isBackgroundColor={false}
                  onClick={onLoadMoreClick}
                  icon="mdi mdi-database-plus mr-2"
                  className="btn text-white btn-block btn-primary "
                />
              </div>
              <div className="col-sm-1"></div>
              <div className="col-sm-4"></div>
            </div>
          </Card>
        </div>
      </div>
    </Starter>
  );
};

export default AllUsers;
